import { propOr } from 'ramda';

import { IMasterAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const getMasterAgentAvatar = (masterAgent?: IMasterAgentSchema): string =>
  propOr('', 'absoluteAvatarUrl', masterAgent);
